import styled from 'styled-components'

export const PageLimitLabelStyled = styled.label`
  padding-right: ${(props) => props.theme.typography.pxToRem(12)};
  vertical-align: middle;
  font-family: inherit;
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
`
